import * as i18next from "i18next";
import { initReactI18next } from "react-i18next";

import de from "./locales/de.json";
import en from "./locales/en.json";

const i18n = i18next.default;

const i18nConfig: i18next.InitOptions = {
  resources: {
    de: { translation: de },
    en: { translation: en },
  },
  lng: "de",
  fallbackLng: "de",
  debug: false,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: true,
  },
};

void i18n.use(initReactI18next).init(i18nConfig);

export default i18n;
